export enum ONBOARDING_CARD_ENUMERATION {
  CARD_TERMS_AND_CONDITIONS = 'card-terms-and-conditons-widget',
  CARD_ERROR = 'card-error-widget',
  CARD_EXPLAIN = 'card-explain-widget',
}
